import { Pipe, PipeTransform } from '@angular/core';

const DECIMAL_PLACES = 2;
const PERCENTAGE_MULTIPLIER = 100;

@Pipe({
  name: 'scorecardPercentage',
  standalone: true,
})
export class ScorecardPercentagePipe implements PipeTransform {
  transform(scoreAchieved: number, totalPossiblePoints: number): number {
    if (totalPossiblePoints <= 0) return 0;
    return Number(((scoreAchieved / totalPossiblePoints) * PERCENTAGE_MULTIPLIER).toFixed(DECIMAL_PLACES));
  }
}
